"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _Text = _interopRequireDefault(require("../Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var styles = {
  "screen-small": "(max-width: 539px)",
  "screen-gt-small": "(min-width: 540px)",
  "screen-medium": "(max-width: 959px)",
  "screen-gt-medium": "(min-width: 960px)",
  "screen-large": "(max-width: 1247px)",
  "screen-gt-large": "(min-width: 1248px)",
  "screen-x-large": "(max-width: 1919px)",
  "screen-gt-x-large": "(min-width: 1920px)",
  "label": "tcl__InputLabel-99efea1b",
  "required": "tcl__InputLabel-25b5d926"
};
/**
 * InputLabel is a basic `<label>` element that can become required and invalid according to
 * its corresponding input.
 */

const InputLabel = ({
  children,
  className,
  isRequired,
  size,
  ...props
}) =>
/*#__PURE__*/
// eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
_react.default.createElement("label", _extends({
  className: (0, _classnames.default)(styles.label, className)
}, (0, _omit.default)(props, ['inputRef', 'isValid'])), /*#__PURE__*/_react.default.createElement(_Text.default, {
  inline: true,
  bold: true,
  color: "black",
  size: size
}, children), isRequired && /*#__PURE__*/_react.default.createElement(_Text.default, {
  inline: true,
  color: "red",
  className: styles.required,
  size: size
}, "*"));

InputLabel.displayName = "InputLabel";
InputLabel.propTypes = {
  /**
   * Any additional css classes.
   */
  className: _propTypes.default.string,

  /**
   * Indicates an error with the corresponding input.
   */
  isValid: _propTypes.default.bool,

  /**
   * Indicates the corresponding input is required.
   */
  isRequired: _propTypes.default.bool,

  /**
   * THe size of the label.
   */
  size: _propTypes.default.oneOf(['small', 'medium']),

  /**
   * Content of label.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired
};
InputLabel.defaultProps = {
  className: '',
  isValid: true,
  isRequired: false,
  size: 'small'
};
var _default = InputLabel;
exports.default = _default;